import * as Awesomplete from 'awesomplete';

export function init(config) {
  const { id, data } = config;

  const input = document.getElementById(id);
  const instance =  new Awesomplete(input, {
    list: Array.from(data, x => x.station + ' ' + x.description)
  });

  return instance;
}
